import * as React from "react";
import { FC } from "react";
import { Edit, EditProps } from "react-admin";
import ReleaseTypeEditForm from "./Forms/ReleaseTypeEditForm";
import { TitleReleaseType } from "./Constant/Source";

const ReleaseTypeEdit: FC<EditProps> = props => {
  return (
    <Edit {...props} title={TitleReleaseType.edit} component="div">
      <ReleaseTypeEditForm {...props} />
    </Edit>
  );
};

export default ReleaseTypeEdit;
